import { useContextState } from "../../../../../../../../hooks/theme"


const useStyles = () => {
    const { colors } = useContextState()
    return {
        container: (isDragging:boolean,isEven:boolean) => ({
            mt:2,
            borderRadius: 1,
            overflow: "hidden",
            bgcolor: isDragging
                ? "rgba(25,118,210,0.08)"
                : "transparent",
            transition: "background-color 0.2s",
            '& .MuiButtonBase-root': {
                padding: 0
            },
            '& .MuiAccordionDetails-root':{
                padding: 0
            },
            '& .MuiAccordionSummary-content':{
                margin: 0
            },
            '& .MuiAccordionSummary-root':{
                minHeight: '56px'
            },
            '& .MuiAccordionSummary-content.Mui-expanded':{
                margin: 0
            },
            '& .MuiInputBase-root': {
                bgcolor: 'white'
            }
        }),
        headerCustom: (par: boolean) => ({
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: 2,
            bgcolor: par ? 'white' : colors.sky/* "rgba(25,118,210,0.05)" */,
            width: '100%'
        }),
        iconContainer: {
            display: "flex", 
            alignItems: "center",
            gap: 1
        },
        rotate: (expand: boolean) => ({
            transition: '200ms',
            transform: `rotate(${expand ? '180deg' : '0deg'})`,
            '& .MuiSvgIcon-root': {
                fontSize: '2rem',
            }
        }),
    }
}

export { useStyles }
